import React from 'react';
import classNames from 'classnames';

import Alert from '../Alert/Alert';

import './AlertDanger.css';

const AlertDanger = props => {
  const classes = classNames('AlertDanger', props.className);

  return (
    <Alert className={classes} alertType="danger">
      <h4>
        {props.error.statusText}
        {props.error.statusText && <br />}
        <small>
          {props.error.message}
        </small>
      </h4>
    </Alert>
  );
};

export default AlertDanger;



// WEBPACK FOOTER //
// ./src/components/alerts/AlertDanger/AlertDanger.js